import { Dispatch, SetStateAction } from 'react';
import cn from 'classnames';
import styles from './MonthPicker.module.scss';
import { Button } from '../../../Button/Button';
import { Icon } from '../../../Icon';

interface MonthPickerI {
  month: string;
  year: string;
  setYear: Dispatch<SetStateAction<string>>;
  setMonth: Dispatch<SetStateAction<string>>;
  startDate: Date;
  endDate: Date;
  setView: Dispatch<SetStateAction<'MONTH' | 'YEAR' | 'DAY'>>;
}

export const MonthPicker = ({
  setMonth,
  setYear,
  year,
  month,
  startDate,
  endDate,
  setView,
}: MonthPickerI) => {
  const nameOfMonthsSpanish = [
    'ENE',
    'FEB',
    'MAR',
    'ABR',
    'MAY',
    'JUN',
    'JUL',
    'AGO',
    'SEP',
    'OCT',
    'NOV',
    'DIC',
  ];

  const renderYears = () => {
    return nameOfMonthsSpanish.map((item, index) => {
      const m = new Date(
        `${(index + 1).toString().padStart(2, '0')}-01-${year} 00:00:00.000`
      );

      const startOfMonth = m.getTime();
      m.setMonth(m.getMonth() + 1);
      m.setDate(0);
      const endOfMonth = new Date(
        `${m.toISOString().split('T')[0]} 23:59:59.999`
      ).getTime();

      const isMonthDisabled =
        endOfMonth <= startDate.getTime() || startOfMonth >= endDate.getTime();

      const key = `${item}-${index}`;
      return (
        <Button
          className={cn(styles.button)}
          isDisabled={isMonthDisabled}
          onClick={() => {
            setMonth((index + 1).toString().padStart(2, '0'));
            setYear(year);
            setView('DAY');
          }}
          key={key}
        >
          {nameOfMonthsSpanish[index]}
        </Button>
      );
    });
  };

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <Button
          isDisabled={
            !(
              new Date(`${month}-01-${Number(year)} 00:00:00.000`).getTime() >
              startDate.getTime()
            )
          }
          className={styles.button}
          onClick={() => setYear((y) => (Number(y) - 1).toString())}
        >
          <Icon type="left-arrow" />
        </Button>
        <div className={styles.years}>{`${year}`}</div>
        <Button
          isDisabled={
            !(
              new Date(
                `${month}-01-${Number(year) + 1} 00:00:00.000`
              ).getTime() < endDate.getTime()
            )
          }
          className={styles.button}
          onClick={() => setYear((y) => (Number(y) + 1).toString())}
        >
          <Icon type="right-arrow" />
        </Button>
      </div>
      <div className={styles['years-container']}>{renderYears()}</div>
    </div>
  );
};
